// extracted by mini-css-extract-plugin
export default {"scenarioSection":"ScenarioSection_scenarioSection__dxeYJ","box":"ScenarioSection_box__Kc8WN","icon":"ScenarioSection_icon__rAHsV"};